import { render } from "./person-military-create-import.vue?vue&type=template&id=7252cdf6"
import script from "./person-military-create-import.vue?vue&type=script&lang=js"
export * from "./person-military-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__